<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[{ text: $t('meta.sensors'), name: 'company_sensors' }, { text: sensor && sensor.hardware_id }]"
        />
      </template>
      <template v-slot:meta>
        <button @click="deleteSensor" class="button button-red button-small button-round">
          {{ $t('sensors.delete') }}
        </button>
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('meta.baseData') }}</h3>
            <div class="header-meta"></div>
          </header>
          <div class="content-body">
            <SensorForm v-if="sensor" @submit="updateSensor" :initialSensor="sensor" />
            <LoadingSpinner v-else />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SensorForm from '@/views/companies/sensors/form'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import sensorsApi from '@/api/sensors'

export default {
  name: 'company_container_type',
  inject: ['showPopup'],
  data: () => ({
    sensor: null,
  }),
  components: {
    BreadCrumbs,
    CompanyNav,
    LoadingSpinner,
    SensorForm,
    SectionHeader,
  },
  methods: {
    updateSensor: async function () {
      const updatedSensor = await sensorsApi.update(this.$route.params.sensor_uuid, this.sensor)
      if (updatedSensor) {
        this.sensor = updatedSensor
      }
    },
    async deleteSensor() {
      const confirmAlert = await this.showPopup({ content: this.$t('sensors.deleteConfirmation'), type: 'confirm' })
      if (!confirmAlert) return null

      const result = await sensorsApi.delete(this.sensor.uuid)

      if (result.success) {
        this.$router.push({ name: 'company_sensors' })
      }
    },
    setPicture() {},
  },
  async mounted() {
    this.sensor = await sensorsApi.get(this.$route.params.sensor_uuid)
  },
}
</script>
